import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'

import { VALIDATIONS } from 'consts'

interface Form {
  name: string
  lastName: string
  email: string
  password: string
}

export const useSignupForm = (defaultValues: Partial<Form>) => {
  const { t } = useTranslation('common')

  const validationSchema = yup.object().shape({
    name: yup.string().required(t('validations.required')),
    lastName: yup.string().required(t('validations.required')),
    email: yup.string().email(t('validations.email')).required(t('validations.required')),
    password: yup
      .string()
      .min(
        VALIDATIONS.PASSWORD_MIN_LENGTH,
        t('validations.minLength', { minLength: VALIDATIONS.PASSWORD_MIN_LENGTH }),
      )
      .required(t('validations.required')),
  })

  return useForm<Form>({ resolver: yupResolver(validationSchema), defaultValues })
}
